import React from "react";
import Alert from "../Alert";

function ImportWalletAlert() {
  return <Alert>Import your wallet to see details</Alert>;
}

export default ImportWalletAlert;
